module.exports = __webpack_public_path__ + "static/banner-3-67da06d56db4e19687792e3edc414e7d.jpg";